export namespace UserRoles {
  export const Forms_Data_Editor: string = 'Forms: Data Editor';
  export const Forms_Auto_Report: string = 'Forms: Auto Report';
  export const Forms_Mobile_User_GridView: string = 'Forms: Mobile User Grid View';
  export const Tools: string = 'Tools';
  export const OriginalID_Feature: string = 'OriginalID Feature';
  export const Purge_Data: string = 'Purge Data';
  export const Library: string = 'Library';
  export const Notification_History_View: string = 'Notification History: View';
  export const API: string = 'API';
  export const Manage_Users_Add_Edit_and_Delete: string = 'Manage Users: Add, Edit and Delete';
  export const Manage_Users_View: string = 'Manage Users: View';
  export const Media: string = 'Media';
  export const User_Groups: string = 'User Groups';
  export const Credits_Transaction_History: string = 'Credits: Transaction History';
  export const Reports: string = 'Reports';
  export const Mobile_Users_Add_to_Group: string = 'Mobile Users: Add to Group';
  export const Mobile_Users_View: string = 'Mobile Users: View';
  export const Mobile_Users_Add_Edit_and_Delete: string = 'Mobile Users: Add, Edit and Delete';
  export const Jobs_Job_Type_Create_Edit_and_Delete: string = 'Jobs: Job Type Create, Edit and Delete';
  export const Jobs_Job_Type_View: string = 'Jobs: Job Type View';
  export const Jobs_View: string = 'Jobs: View';
  export const Jobs_Allocate_Deallocate_and_lose: string = 'Jobs: Allocate, Deallocate and Close';
  export const Jobs_Create_Edit_and_Delete: string = 'Jobs: Create, Edit and Delete';
  export const Forms_Form_Dashboard_Settings_Publish_Location_Drafts_Auto_upload: string = 'Forms: Form Dashboard Settings (Publish, Location, Drafts & Auto-upload)';
  export const Forms_Notifications: string = 'Forms: Notifications';
  export const Forms_Shred_Data: string = 'Forms: Shred Data';
  export const Forms_Share_Form_Data: string = 'Forms: Share Form Data';
  export const Forms_View_Form_Data_and_Download: string = 'Forms: View Form Data and Download';
  export const Forms_Create_Edit_and_Delete: string = 'Forms: Create, Edit and Delete';
  export const Forms_View: string = 'Forms: View';
  export const WMConnectReports_View: string = 'WMConnectReports: View';
  export const Catalogues_Create_Edit_and_Delete: string = 'Catalogues: Add, Edit and Delete';
  export const Catalogues_View: string = 'Catalogues: View';
  export const Record_Templates: string = 'Record Templates';
  export const Lone_Worker_Configuration: string = 'Lone Worker: Configuration';
  export const Lone_Worker_Events: string = 'Lone Worker: Events';
  export const Lone_Worker_Reports: string = 'Location Tracking: Reports';
  export const Location_Tracking: string = 'Location Tracking';
  export const CRM_View: string = 'CRM: View';
  export const CRM_Add_Edit_and_Delete: string = 'CRM: Add, Edit and Delete';
}
